import React, { useEffect } from "react";
import LandingHeader from "./sections/LandingHeader.jsx";
import LandingNav from "./sections/LandingNav.jsx";
import LandingFooter from "./sections/LandingFooter.jsx";
import "../../styles/new-landing.css";
import { useTranslation } from "react-i18next";

const AboutSulhafaConnect = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir && i18n.dir() === "rtl";

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <LandingHeader />
      <LandingNav />
      <div className={`about-connect-container ${isRTL ? 'rtl' : 'ltr'}`}>
        <div className="about-connect-content">
          <div className="about-connect-text">
            <h1 className="about-connect-title">{t('aboutConnect.hero.title')}</h1>
            <p className="about-connect-desc">
              {t('aboutConnect.hero.description')}
              <br /><br />
              <strong>{t('aboutConnect.hero.description2')}</strong>
            </p>
          </div>
          <div className="about-connect-image">
            <img
              src="/images/Sulhafa-Community.png"
              alt={t('landingFooter.exploreSulhafa.sulhafaConnect')}
              style={{ transform: isRTL ? "scaleX(-1)" : "none" }}
            />
          </div>
        </div>

        {/* Vision Section */}
        <div className="connect-vision-section">
          <div className="connect-vision-content">
            <p className="connect-vision-text">
              {t('aboutConnect.vision.text')}
            </p>
          </div>
        </div>

        {/* What Makes Us Different Section */}
        <div className="connect-features-section">
          <h2 className="connect-features-title">{t('aboutConnect.features.title')}</h2>
          <div className="connect-features-grid">
            <div className="connect-feature-card">
              <div className="connect-feature-icon" style={{ background: "#e74c3c" }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.51 4.04 3 5.5Z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M12 5L8 21l4-7 4 7-4-16" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3>{t('aboutConnect.features.diaries.title')}</h3>
              <p>{t('aboutConnect.features.diaries.description')}</p>
            </div>

            <div className="connect-feature-card">
              <div className="connect-feature-icon" style={{ background: "#3498db" }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="#fff" strokeWidth="2" />
                  <circle cx="9" cy="7" r="4" stroke="#fff" strokeWidth="2" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="#fff" strokeWidth="2" />
                </svg>
              </div>
              <h3>{t('aboutConnect.features.groups.title')}</h3>
              <p>{t('aboutConnect.features.groups.description')}</p>
            </div>  


            <div className="connect-feature-card">
              <div className="connect-feature-icon" style={{ background: "#27ae60" }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3" stroke="#fff" strokeWidth="2" />
                  <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3" stroke="#fff" strokeWidth="2" />
                  <path d="M12 21c0-1-1-3-3-3s-3 2-3 3 1 3 3 3 3-2 3-3" stroke="#fff" strokeWidth="2" />
                  <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3" stroke="#fff" strokeWidth="2" />
                </svg>
              </div>
              <h3>{t('aboutConnect.features.voices.title')}</h3>
              <p>{t('aboutConnect.features.voices.description')}</p>
            </div>
          </div>
        </div>

        {/* User Benefits Section */}
        <div className="connect-benefits-section">
          <h2 className="connect-benefits-title">{t('aboutConnect.benefits.title')}</h2>

          <div className="connect-benefits-cards">
            {/* Pet Guardians */}
            <div className="connect-benefit-card guardians">
              <div className="connect-benefit-icon" style={{ background: "#8548a8" }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="#fff" strokeWidth="2" />
                  <circle cx="12" cy="7" r="4" stroke="#fff" strokeWidth="2" />
                  <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2" stroke="#fff" strokeWidth="2" />
                </svg>
              </div>
              <h3>{t('aboutConnect.benefits.guardians.title')}</h3>
              <p>{t('aboutConnect.benefits.guardians.description')}</p>
            </div>

            {/* Veterinarians */}
            <div className="connect-benefit-card vets">
              <div className="connect-benefit-icon" style={{ background: "#2a8ad2" }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <path d="M22 12h-4l-3 9L9 3l-3 9H2" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <circle cx="12" cy="8" r="3" stroke="#fff" strokeWidth="2" />
                </svg>
              </div>
              <h3>{t('aboutConnect.benefits.veterinarians.title')}</h3>
              <p>{t('aboutConnect.benefits.veterinarians.description')}</p>
            </div>

            {/* Service Providers */}
            <div className="connect-benefit-card providers">
              <div className="connect-benefit-icon" style={{ background: "#ff9c5a" }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="#fff" strokeWidth="2" />
                  <circle cx="8.5" cy="7" r="4" stroke="#fff" strokeWidth="2" />
                  <path d="M20 8v6M23 11l-3 3-3-3" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <circle cx="18" cy="5" r="3" stroke="#fff" strokeWidth="2" />
                </svg>
              </div>
              <h3>{t('aboutConnect.benefits.providers.title')}</h3>
              <p>{t('aboutConnect.benefits.providers.description')}</p>
            </div>
          </div>
        </div>

        {/* Closing Statement */}
        <div className="connect-closing-section">
          <div className="connect-closing-content">
            <h2 className="connect-closing-title">{t('aboutConnect.closing.title')}</h2>
            <h3 className="connect-closing-subtitle">{t('aboutConnect.closing.subtitle')}</h3>
          </div>
        </div>
      </div>
      <LandingFooter />
    </>
  );
};

export default AboutSulhafaConnect;
